import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import Page from 'components/Page';
import globalMessages from 'translations/messages';
import { EMAIL_TEMPLATE_SETTINGS } from 'shared/constants/settings';
import SettingsList from 'components/Settings/SettingsList';
import SettingsDrawer from 'components/Settings/SettingsDrawer';

const EmailTemplateSettings = () => {
  const [edit, setEdit] = useState(false);

  return (
    <Page>
      <Page.Header
        title="Email Template Settings"
        extra={(
          <Button type="primary" onClick={() => setEdit(true)} icon={<EditOutlined />}>
            <FormattedMessage {...globalMessages.edit} />
          </Button>
        )}
      />
      <Page.Content>
        <SettingsList settings={EMAIL_TEMPLATE_SETTINGS} relationId={null} refresh={!edit} />
        <SettingsDrawer settings={EMAIL_TEMPLATE_SETTINGS} relationId={null} open={edit} onDone={() => setEdit(false)} onCancel={() => setEdit(false)} />
      </Page.Content>
    </Page>
  );
};

export default EmailTemplateSettings;
